import { render, staticRenderFns } from "./version-compatible-error.vue?vue&type=template&id=4da64289"
import script from "./version-compatible-error.vue?vue&type=script&lang=js"
export * from "./version-compatible-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports